const isProd = process.env.GATSBY_ENV === "production";
export function isProduction() {
  return isProd;
}

export function isDev() {
  return !isProd;
}

export function homeBaseURL() {
  return isDev() ? "https://home.classdojo.test:8085" : "https://home.classdojo.com";
}
export function studentBaseURL() {
  return isDev() ? "https://student.classdojo.test:8089" : "https://student.classdojo.com";
}

type Websites = "www" | "mobile" | "blog" | "dev-blog" | "ideas";

export function getBuildWebiste(): Websites {
  return process.env.GATSBY_BUILD_WEBSITE as Websites;
}
